/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./locale-data/complete.js (ignored)
// module id = 0
// module chunks = main polyfills